import { typography } from './typography'


export const space = {
  ...typography.fontSizes,
}
